import { useState } from "react";
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";

interface DownloadCSVZipActionProps {
  event:{
    id : number;
    location: string;
    start_date: string;
    song_csv_upload_meta: string | {
      download_csv_path:string;
    }
  }
}

function DownloadCSVZipAction({ event }: DownloadCSVZipActionProps) {

  let song_csv = null;
  let song_csv_path = null;

  const song_csv_meta = event?.song_csv_upload_meta;

  if (typeof song_csv_meta === 'string') {
      song_csv = JSON.parse(song_csv_meta);
      song_csv_path = song_csv?.download_csv_path;
  }else{
      song_csv = "";
      song_csv_path = "";
  }


  const fixed_song_csv_path = song_csv_path?.replace(/\\/g, '/') || '';
  const fileName = fixed_song_csv_path?.replace('storage/uploads_music/', '') || '';
  const hasValidPath = fileName && fileName.length > 0;
  
  const [loading, setLoading] = useState(false);

const handleDownloadCSVZip = async () => {
  if (!hasValidPath) {
    toast.warn("No CSV files available for download");
    return;
  }
  try {
    setLoading(true);
    const token = localStorage.getItem('token'); 
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/admin/musiccsv/${fileName}`,
      {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      try {
        const errorData = JSON.parse(errorText);
        toast.warn(errorData?.message || 'Download failed');
      } catch {
        toast.warn(`Download failed: ${response.status}`);
      }
      return;
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    toast.info('CSV zip downloaded successfully!');
    
  } catch (error) {
    console.error("Failed to download CSV zip", error);
    toast.warn("Failed to download CSV zip");
  } finally {
    setLoading(false);
  }
};

return (
  <Tooltip 
    title={hasValidPath ? "Download CSV files" : "No CSV files available"} 
    enterDelay={0} 
    leaveDelay={0}
  >
    <button
      className="download-csv-btn"
      onClick={handleDownloadCSVZip}
      disabled={loading || !hasValidPath}
      style={{
        cursor: (loading || !hasValidPath) ? "not-allowed" : "pointer",
        opacity: (loading || !hasValidPath) ? 0.5 : 1,
      }}
    >
      <DownloadIcon style={{ fontSize: '25px' }} />
      <span>
        {loading ? 'Downloading...' : 'Download Original CSV'}
      </span>
    </button>
  </Tooltip>
);
}

export default DownloadCSVZipAction;